import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Navbar from 'reactstrap/lib/Navbar';
import Container from 'reactstrap/lib/Container';
import { get } from 'lodash';
import classnames from 'classnames';

import { LogoSection } from './logo-section';

function GlobalNavigationEmptyUI({ isMobile, isSmall }) {
  const mobile = isMobile || isSmall;
  return (
    <div className="global-navigation w-100" data-tracking-parent="edm-entry-global-nav">
      <Container className="px-0">
        <Navbar
          className={classnames(
            { 'global-navigation-desktop': !mobile, 'global-navigation-mobile': mobile },
            'flex-row align-items-center'
          )}
          aria-label="Main Navigation"
        >
          <LogoSection />
        </Navbar>
      </Container>
    </div>
  );
}

GlobalNavigationEmptyUI.propTypes = {
  isMobile: PropTypes.bool,
  isSmall: PropTypes.bool,
};

GlobalNavigationEmptyUI.defaultProps = {
  isMobile: false,
  isSmall: false,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
  isSmall: get(state, 'pageContext.isSmallDeprecated', false),
});

export const GlobalNavigationEmpty = connect(mapStateToProps)(GlobalNavigationEmptyUI);
